import perlegoBooks from 'assets/icons/perlego-books@2x.png';
import safetyWings from 'assets/icons/safety-wings.svg';
import SIXTlogo from 'assets/images/SIXT@2x.png';
import airalo from 'assets/images/airalo@2x.png';
import beehiiv from 'assets/images/beehiiv@2x.png';
import betterHelp from 'assets/images/better_help.png';
import corel from 'assets/images/corel@2x.png';
import freshBooks from 'assets/images/fresh-books@2x.png';
import genki from 'assets/images/genki@2x.png';
import headout from 'assets/images/headout@2x.png';
import i18n from 'i18n';
import littleEmperors from 'assets/images/little_emperors@2x.png';
import mentorCruise from 'assets/images/mentor-cruise@2x.png';
import moreMines from 'assets/images/mode-mines@2x.png';
import moralisAcademy from 'assets/images/moralis_academy@2x.png';
import parallels from 'assets/images/parallels@2x.png';
import spotahome from 'assets/images/spotahome@2x.png';
import synthesia from 'assets/images/synthesia@2x.png';
import tiketcAtWokr from 'assets/images/tickets_at_work.png';
import wise from 'assets/images/wise@2x.png';
import womenInTech from 'assets/images/women-in-tech@2x.png';
import worknmates from 'assets/images/worknmates@2x.png';
import React from 'react';

import { Box } from '@mui/material';

import { OptionType } from '@libs/ui/components/form/select';
import Typography from '@libs/ui/components/typography';

import { PerkRegion } from '../types';
import { PromoActions, UrlActions } from './perk-card';
import { PerkCardV2Props } from './perk-card-2';

const tp = (key: string) => i18n.t(key, { ns: 'perks' });

const WINGS: PerkCardV2Props = {
  title: tp('cards.safetyWing.title'),
  subtitle: tp('cards.safetyWing.subtitle'),
  couponText: '-35%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.safetyWing.text')}
      </Typography>
    </Box>
  ),
  logo: safetyWings,
  serviceName: 'SafetyWing',
  actions: (
    <UrlActions url="https://safetywing.com/remote-health/member/signup/OpenTalent" />
  ),
  regions: [PerkRegion.Global],
};
const BETTER_HELP: PerkCardV2Props = {
  title: tp('cards.betterHelp.title'),
  subtitle: tp('cards.betterHelp.subtitle'),
  couponText: '-50%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.betterHelp.text')}
      </Typography>
    </Box>
  ),
  logo: betterHelp,
  logo2x: betterHelp,
  serviceName: 'BetterHelp',
  actions: <UrlActions url="http://www.betterhelp.com/opentalent" />,
  regions: [PerkRegion.Global, PerkRegion.US],
};
const PERLEGO_BOOKS: PerkCardV2Props = {
  title: tp('cards.perlegoBooks.title'),
  subtitle: tp('cards.perlegoBooks.subtitle'),
  couponText: '-15%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.perlegoBooks.text')}
      </Typography>
    </Box>
  ),
  logo: perlegoBooks,
  logo2x: perlegoBooks,
  serviceName: 'Perlego Books',
  actions: (
    <UrlActions url="https://www.perlego.com/?irclickid=RJ723IXW2xyNW4R0t9xkiVtHUkFzA5T0-0ksz40&utm_source=OpenTalent&utm_medium=&utm_campaign=Open%20Talent%3A%2015%25%20off%2012%20months&utm_content=COUPON&discount=OPENTALENT15&irgwc=1" />
  ),
  regions: [PerkRegion.Global],
};

const WORKNMATES: PerkCardV2Props = {
  title: tp('cards.worknmates.title'),
  subtitle: tp('cards.worknmates.subtitle'),
  couponText: '-15%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.worknmates.text')}
      </Typography>
    </Box>
  ),
  logo: worknmates,
  logo2x: worknmates,
  serviceName: 'Worknmates',
  actions: <UrlActions url="https://worknmates.com/perk/129" />,
  regions: [PerkRegion.Global],
};

const MOREMINS: PerkCardV2Props = {
  title: tp('cards.moreMins.title'),
  subtitle: tp('cards.moreMins.subtitle'),
  couponText: '-50%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.moreMins.text')}
      </Typography>
    </Box>
  ),
  logo: moreMines,
  logo2x: moreMines,
  serviceName: 'MoreMins',
  actions: (
    <UrlActions url="https://www.moremins.com/en/app/login?ref=otc5otq" />
  ),
  regions: [PerkRegion.Global],
};

const GENKI: PerkCardV2Props = {
  title: tp('cards.genki.title'),
  subtitle: tp('cards.genki.subtitle'),
  couponText: 'DEAL',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.genki.text')}
      </Typography>
    </Box>
  ),
  logo: genki,
  logo2x: genki,
  serviceName: 'Genki',
  actions: <UrlActions url="https://www.genki.world/with/opentalent" />,
  regions: [PerkRegion.Global, PerkRegion.US],
};

const SPOTAHOME: PerkCardV2Props = {
  title: tp('cards.spotahome.title'),
  subtitle: tp('cards.spotahome.subtitle'),
  couponText: '-20%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.spotahome.text')}
      </Typography>
    </Box>
  ),
  logo: spotahome,
  logo2x: spotahome,
  serviceName: 'Spotahome',
  actions: (
    <PromoActions
      code="OPENTALENT20"
      url="https://www.spotahome.com"
      moreInfoUrl="https://main.ottest.co/files/one-pager_opentalent20_spotahome_promo_code.pdf"
    />
  ),
  regions: [PerkRegion.Global],
};

const MORALIS_ACADEMY: PerkCardV2Props = {
  title: tp('cards.moralisAcademy.title'),
  subtitle: tp('cards.moralisAcademy.subtitle'),
  couponText: '-50%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.moralisAcademy.text')}
      </Typography>
    </Box>
  ),
  logo: moralisAcademy,
  logo2x: moralisAcademy,
  serviceName: 'Moralis Academy',
  actions: (
    <UrlActions url="https://academy.moralis.io/direct-sales?ref=3399" />
  ),
  regions: [PerkRegion.Global],
};

const LITTLE_EMPERORS: PerkCardV2Props = {
  title: tp('cards.littleEmperors.title'),
  subtitle: tp('cards.littleEmperors.subtitle'),
  couponText: '-£299',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.littleEmperors.text')}
      </Typography>
    </Box>
  ),
  logo: littleEmperors,
  logo2x: littleEmperors,
  serviceName: 'Little Emperors',
  actions: (
    <PromoActions
      url="https://littleemperors.com/opentalent"
      code="opentalent"
      moreInfoUrl="https://main.ottest.co/files/introducing_little_emperors.pdf"
    />
  ),
  regions: [PerkRegion.Global],
};

const HELLO_AI: PerkCardV2Props = {
  title: tp('cards.helloAI.title'),
  subtitle: tp('cards.helloAI.subtitle'),
  couponText: '-50%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.helloAI.text')}
      </Typography>
    </Box>
  ),
  logo: 'https://www.app.hallo.tv/static/media/hallo_primary_logo.4d2d37a4.png',
  logo2x:
    'https://www.app.hallo.tv/static/media/hallo_primary_logo.4d2d37a4.png',
  serviceName: 'HelloAI',
  actions: (
    <PromoActions
      url="http://www.app.hallo.tv/hallo-plus"
      code="HalloOpenTalent23"
    />
  ),
  regions: [PerkRegion.Global],
};

const AIRALO: PerkCardV2Props = {
  title: tp('cards.airalo.title'),
  subtitle: tp('cards.airalo.subtitle'),
  couponText: '-10%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.airalo.text')}
      </Typography>
    </Box>
  ),
  logo: airalo,
  logo2x: airalo,
  serviceName: 'airalo',
  actions: (
    <PromoActions
      url="https://www.airalo.com/auth/signup"
      code="OPENTALENT10"
    />
  ),
  regions: [PerkRegion.Global, PerkRegion.US],
};

const BEEHIIV: PerkCardV2Props = {
  title: tp('cards.beehiiv.title'),
  subtitle: tp('cards.beehiiv.subtitle'),
  couponText: '-20%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.beehiiv.text')}
      </Typography>
    </Box>
  ),
  logo: beehiiv,
  logo2x: beehiiv,
  serviceName: 'beehiiv',
  actions: (
    <PromoActions url="https://www.beehiiv.com/?via=opentalent" code="OT20" />
  ),
  regions: [PerkRegion.Global, PerkRegion.US],
};

const WISE: PerkCardV2Props = {
  title: tp('cards.wise.title'),
  subtitle: tp('cards.wise.subtitle'),
  couponText: 'DEAL',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.wise.text')}
      </Typography>
    </Box>
  ),
  logo: wise,
  logo2x: wise,
  serviceName: 'Wise',
  actions: <UrlActions url="https://wise.prf.hn/l/OV9zkLZ" />,
  regions: [PerkRegion.Global, PerkRegion.US],
};

const SYNTHESIA: PerkCardV2Props = {
  title: tp('cards.synthesia.title'),
  subtitle: tp('cards.synthesia.subtitle'),
  couponText: '-30%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.synthesia.text')}
      </Typography>
    </Box>
  ),
  logo: synthesia,
  logo2x: synthesia,
  serviceName: 'Synthesia',
  actions: <UrlActions url="https://www.synthesia.io/?via=opentalent" />,
  regions: [PerkRegion.Global, PerkRegion.US],
};

const MENTOR_CRUISE: PerkCardV2Props = {
  title: tp('cards.mentorCruise.title'),
  subtitle: tp('cards.mentorCruise.subtitle'),
  couponText: '-20%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.mentorCruise.text')}
      </Typography>
    </Box>
  ),
  logo: mentorCruise,
  logo2x: mentorCruise,
  serviceName: 'MentorCruise',
  actions: <UrlActions url="https://mentorcruise.com/partner/opentalent/" />,
  regions: [PerkRegion.Global, PerkRegion.US],
};

const FRESH_BOOKS: PerkCardV2Props = {
  title: tp('cards.freshBooks.title'),
  subtitle: tp('cards.freshBooks.subtitle'),
  couponText: '-50%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.freshBooks.text')}
      </Typography>
    </Box>
  ),
  logo: freshBooks,
  logo2x: freshBooks,
  serviceName: 'FreshBooks',
  actions: <UrlActions url="https://shrsl.com/48b7z" />,
  regions: [PerkRegion.Global, PerkRegion.US],
};

const COREL: PerkCardV2Props = {
  title: tp('cards.corel.title'),
  subtitle: tp('cards.corel.subtitle'),
  couponText: 'DEAL',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.corel.text')}
      </Typography>
    </Box>
  ),
  logo: corel,
  logo2x: corel,
  serviceName: 'Corel',
  actions: <UrlActions url="https://prf.hn/l/RmV5gbn" />,
  regions: [PerkRegion.Global, PerkRegion.US],
};

const PARALLELS: PerkCardV2Props = {
  title: tp('cards.parallels.title'),
  subtitle: tp('cards.parallels.subtitle'),
  couponText: '-10%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.parallels.text')}
      </Typography>
    </Box>
  ),
  logo: parallels,
  logo2x: parallels,
  serviceName: 'Parallels',
  actions: <PromoActions code="58L-KFB-931" url="https://prf.hn/l/RmV5gbn" />,
  regions: [PerkRegion.Global, PerkRegion.US],
};

const HEADOUT: PerkCardV2Props = {
  title: tp('cards.headout.title'),
  subtitle: tp('cards.headout.subtitle'),
  couponText: 'DEAL',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.headout.text')}
      </Typography>
    </Box>
  ),
  logo: headout,
  logo2x: headout,
  serviceName: 'Headout',
  actions: (
    <UrlActions url="https://www.headout.com/r/opentalentrecommends-BWLRw/" />
  ),
  regions: [PerkRegion.Global, PerkRegion.US],
};

const SIXT: PerkCardV2Props = {
  title: tp('cards.sixt.title'),
  subtitle: tp('cards.sixt.subtitle'),
  couponText: '-10%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.sixt.text')}
      </Typography>
    </Box>
  ),
  logo: SIXTlogo,
  logo2x: SIXTlogo,
  serviceName: 'SIXT',
  actions: <UrlActions url="http://www.sixt.co.uk/opentalent" />,
  regions: [PerkRegion.Global, PerkRegion.US],
};

const WOMEN_IN_TECH: PerkCardV2Props = {
  title: tp('cards.womenInTech.title'),
  subtitle: tp('cards.womenInTech.subtitle'),
  couponText: '-20%',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.womenInTech.text')}
      </Typography>
    </Box>
  ),
  logo: womenInTech,
  logo2x: womenInTech,
  serviceName: 'European Women in Tech',
  actions: (
    <PromoActions
      code="OPENTALENT20"
      moreInfoUrl="https://europeanwomenintech.com/"
      url="https://europeanwomenintech.com/buy-tickets/"
    />
  ),
  regions: [PerkRegion.Global],
};

const TICKETS_AT_WORK: PerkCardV2Props = {
  title: tp('cards.ticketsAtWork.title'),
  subtitle: tp('cards.ticketsAtWork.subtitle'),
  couponText: 'DEAL',
  text: (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {tp('cards.ticketsAtWork.text')}
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        {tp('cards.ticketsAtWork.textNote')}{' '}
        <b>Impellam</b>.
      </Typography>
    </Box>
  ),
  logo: tiketcAtWokr,
  logo2x: tiketcAtWokr,
  serviceName: 'TicketsAtWork',
  actions: (
    <PromoActions code="Impellam" url="https://www.ticketsatwork.com/" />
  ),
  regions: [PerkRegion.Global, PerkRegion.US],
};

export const CARDS_DATA = [
  BETTER_HELP,
  WINGS,
  PERLEGO_BOOKS,
  WORKNMATES,
  MOREMINS,
  GENKI,
  SPOTAHOME,
  MORALIS_ACADEMY,
  LITTLE_EMPERORS,
  HELLO_AI,
  AIRALO,
  BEEHIIV,
  WISE,
  SYNTHESIA,
  MENTOR_CRUISE,
  FRESH_BOOKS,
  COREL,
  PARALLELS,
  HEADOUT,
  SIXT,
  WOMEN_IN_TECH,
  TICKETS_AT_WORK,
];

export const CATEGORIES_OPTIONS: OptionType[] = Array.from(
  new Set(CARDS_DATA.map((i) => i.subtitle!).filter(Boolean)),
).map((i) => ({ text: i, value: i }));
